export default __webpack_public_path__ + "5aade8831696c66ed1e0386acf5b44c1.png";